// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import type GetTimeZoneOffsetsJsonRequest from '../contract/GetTimeZoneOffsetsJsonRequest';

export default function getTimeZoneOffsetsJsonRequest(
    data: GetTimeZoneOffsetsJsonRequest
): GetTimeZoneOffsetsJsonRequest {
    const result: GetTimeZoneOffsetsJsonRequest = {
        __type: 'GetTimeZoneOffsetsJsonRequest:#Exchange',
        ...data,
    };

    return result;
}
